import { atomWithStorage } from "jotai/utils";
import { StoreKeys } from "./store-keys";

export const levelsAtom = atomWithStorage<number[] | null>(
  `Xtremis_CarbonTech_${StoreKeys.Levels}`,
  null,
);
